import get from 'transmute/get';
export const getStartOpen = get('startOpen');